import { hasIubendaConsent } from "@/lib/iubendaConsent";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/**
 * Push a custom event to GTM dataLayer (GA4 via GTM tags).
 * No-ops without analytics consent — aligns with halomora-live-readiness-guide.
 */
export function pushGtmEvent(eventName: string, payload: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  if (!hasIubendaConsent()) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...payload });
}

export function trackClickCta(ctaId: string, extra: Record<string, unknown> = {}) {
  pushGtmEvent("click_cta", { cta_id: ctaId, ...extra });
}
